import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// 僅允許管理員 或 部門管理員 訪問
const AdminOrDeptAdminRoute = ({
  component: Component,
  auth: { isAuthenticated, loading, isAdmin, isDeptAdmin, user },
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (!loading && (!isAuthenticated || (!isAdmin && !isDeptAdmin))) {
        return <Redirect to='/login' />;
      } else if (!loading && user) {
        return <Component {...props} />;
      }
      return null;
    }}
  />
);

AdminOrDeptAdminRoute.propTypes = {
  auth: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  auth: state.auth
});

export default connect(mapStateToProps)(AdminOrDeptAdminRoute);
